var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"basic-component"},[_c('div',[_vm._v(_vm._s(_vm.$t('search_color_wechat')))]),_c('div',[(_vm.qrImg)?_c('img',{attrs:{"src":_vm.qrImg}}):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }